'use strict';

exports.__esModule = true;
exports.Grid_B = exports.Grid_A = exports.WF_GRID_B = exports.WF_GRID_A = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsUtils = require('widgets-utils');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _reviewItem = require('widgets-utils/src/styles/review-item.scss');

var _reviewItem2 = _interopRequireDefault(_reviewItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WF_GRID_A = exports.WF_GRID_A = 'WF_GRID_A';
var WF_GRID_B = exports.WF_GRID_B = 'WF_GRID_B';

var Grid_A = exports.Grid_A = function Grid_A(props) {
    var bodyStyle = props.bodyStyle;
    return _react2.default.createElement(
        'div',
        {
            className: [_style2.default.wrapper, _style2.default.wrapper_a, bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent" && _reviewItem2.default["transparent-body"] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame']].join(' ')
        },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'a',
                {
                    href: props.href,
                    className: _style2.default["doctify-logo"],
                    target: '_blank',
                    rel: 'nofollow noopener'
                },
                _react2.default.createElement(
                    'div',
                    { className: _style2.default["logo-span"] },
                    'Verified by'
                ),
                _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                    logoSize: _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL,
                    logoTheme: _widgetsUtils.DoctifyLogo.LOGO_THEME_COLORED,
                    logoType: _widgetsUtils.DoctifyLogo.LOGO_TYPE_WORD
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: [_style2.default.reviews, _style2.default.reviews_a].join(' ') },
            props.reviews.map(function (review) {
                var date = new Date(review.timestamp_created);
                var dateFormatted = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
                return _react2.default.createElement(
                    'div',
                    { className: _style2.default["review-item_a"] },
                    _react2.default.createElement(_widgetsUtils.ReviewItem, {
                        key: review.id,
                        rate: review.aggregate_score,
                        content: review.review.body,
                        date: dateFormatted,
                        isReviewVerified: review.is_verified,
                        contentStyle: { height: '70px' },
                        wrapperStyle: { "background-color": props.reviewItemBackground },
                        showFrame: props.reviewItemFrame
                    })
                );
            })
        )
    );
};

var Grid_B = exports.Grid_B = function Grid_B(props) {
    var reviews = props.reviews.slice(0, 4);
    var bodyStyle = props.bodyStyle;
    return _react2.default.createElement(
        'div',
        {
            className: [_style2.default.wrapper, _style2.default.wrapper_b, bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent" && _reviewItem2.default["transparent-body"] || '', props.wrapperFrame === false && _style2.default['wrapper_no-frame']].join(' ')
        },
        _react2.default.createElement(
            'div',
            { className: [_style2.default.reviews, _style2.default.reviews_b].join(' ') },
            reviews.map(function (review) {
                var date = new Date(review.timestamp_created);
                var dateFormatted = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
                return _react2.default.createElement(
                    'div',
                    { className: _style2.default["review-item_b"] },
                    _react2.default.createElement(_widgetsUtils.ReviewItem, {
                        key: review.id,
                        rate: review.aggregate_score,
                        content: review.review.body,
                        date: dateFormatted,
                        isReviewVerified: review.is_verified,
                        contentStyle: { height: '70px' },
                        wrapperStyle: { "background-color": props.reviewItemBackground },
                        showFrame: props.reviewItemFrame
                    })
                );
            })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'a',
                {
                    href: props.href,
                    className: _style2.default["doctify-logo"],
                    target: '_blank',
                    rel: 'nofollow noopener'
                },
                _react2.default.createElement(
                    'div',
                    { className: _style2.default["logo-span"] },
                    'Verified by'
                ),
                _react2.default.createElement(_widgetsUtils.DoctifyLogo, {
                    logoSize: _widgetsUtils.DoctifyLogo.LOGO_SIZE_SMALL,
                    logoTheme: _widgetsUtils.DoctifyLogo.LOGO_THEME_COLORED,
                    logoType: _widgetsUtils.DoctifyLogo.LOGO_TYPE_WORD
                })
            )
        )
    );
};